import { motion } from "motion/react";

import { cn } from "@/lib/utils";
import AppLogoIcon from "@/components/LogoIcon";

interface GenericLoaderProps {
  className?: string;
}

const GenericLoader = ({ className }: GenericLoaderProps) => {
  return (
    <div
      className={cn(
        "bg-background absolute inset-0 z-50 flex items-center justify-center",
        className,
      )}
    >
      <div className="relative h-24 w-24">
        {/* Pulse ring effect */}
        <motion.div
          animate={{
            scale: [1, 1.05, 1],
            opacity: [0.3, 0.1, 0.3],
          }}
          className="bg-accent-foreground/40 absolute inset-0 rounded-full"
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Rotating gradient ring */}
        <motion.div
          animate={{ rotate: 360 }}
          className="absolute inset-0"
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          <div className="from-accent-foreground h-full w-full rounded-full bg-gradient-to-r via-transparent to-transparent p-0.5">
            <div className="bg-background h-full w-full rounded-full" />
          </div>
        </motion.div>

        {/* Logo in the center - stays static */}
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.div
            animate={{
              scale: [1, 1.05, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <AppLogoIcon className="h-10 w-10" />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default GenericLoader;
